function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { getWidget, getUiOptions } from "../utils";

class ArrayFieldFiles extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onSelectChange", value => {
      this.props.onChange(value);
    });
  }

  render() {
    const _this$props = this.props,
          schema = _this$props.schema,
          uiSchema = _this$props.uiSchema,
          idSchema = _this$props.idSchema,
          name = _this$props.name,
          disabled = _this$props.disabled,
          readonly = _this$props.readonly,
          autofocus = _this$props.autofocus,
          onBlur = _this$props.onBlur,
          onFocus = _this$props.onFocus,
          registry = _this$props.registry,
          rawErrors = _this$props.rawErrors;
    const title = schema.title || name;
    const items = this.props.formData;
    const widgets = registry.widgets,
          formContext = registry.formContext;

    const _getUiOptions = getUiOptions(uiSchema),
          _getUiOptions$widget = _getUiOptions.widget,
          widget = _getUiOptions$widget === void 0 ? "files" : _getUiOptions$widget,
          options = _objectWithoutPropertiesLoose(_getUiOptions, ["widget"]);

    const Widget = getWidget(schema, widget, widgets);
    return React.createElement(Widget, {
      options: options,
      id: idSchema && idSchema.$id,
      multiple: true,
      onChange: this.onSelectChange,
      onBlur: onBlur,
      onFocus: onFocus,
      schema: schema,
      title: title,
      value: items,
      disabled: disabled,
      readonly: readonly,
      formContext: formContext,
      autofocus: autofocus,
      rawErrors: rawErrors
    });
  }

}

export default ArrayFieldFiles;